import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
import { DdPage } from "@/CodegenTypes";
import { apolloClient, mutations } from "@/apollo";
import { clone } from "lodash";
import { errorMutationNotification } from "@/utils";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'RenamePageModal',
  props: {
    page: null,
    value: { type: Boolean, default: false }
  },
  emits: ["input", "submit"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", val: boolean): void;
  (e: "submit"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { page: DdPage, value: boolean };





const { $t } = useTranslation();
const t = (text: string) => $t(text);

const form = ref(getDefaultForm());

function toggleModal(val: boolean) {
  emit("input", val);
}

function getDefaultForm() {
  return clone({
    name: props.page.name
  });
}

function resetForm() {
  form.value = getDefaultForm();
}

watch(() => props.page, resetForm);

async function handleSubmit() {
  try {
    await apolloClient.mutate({
      mutation: mutations.renameDdPage,
      variables: {
        id: props.page.id,
        newName: form.value.name
      }
    });
    emit("submit");
    toggleModal(false);
  } catch (err) {
    errorMutationNotification(err);
  }
}

return { __sfc: true,props, emit, $t, t, form, toggleModal, getDefaultForm, resetForm, handleSubmit }
}

})